<div cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  <div class="text-center drag-handle" cdkDragHandle>
    <h2 mat-dialog-title class="headerCustomTitlePopup">{{ "CALENDAR.VIEWEVENT.TITLE" | translate }}</h2>
  </div>
</div>

<mat-dialog-content class="pt-4" style="max-height: 55vh; overflow-y: auto">
  <!-- Messaggio di errore se eventData è null -->
  @if (!eventData || !eventData.idevent) {
    <div class="container-fluid">
      <div class="alert alert-danger d-flex align-items-center" role="alert">
        <i class="bi bi-exclamation-triangle-fill me-2" style="font-size: 1.5rem;"></i>
        <div>
          <h5 class="alert-heading mb-1">{{ "CALENDAR.VIEWEVENT.ERROR_TITLE" | translate }}</h5>
          <p class="mb-0">{{ "CALENDAR.VIEWEVENT.ERROR_MESSAGE" | translate }}</p>
        </div>
      </div>
    </div>
  }
  <!-- Contenuto normale se eventData è presente -->
  @if (eventData && eventData.idevent) {
    <div class="container-fluid">
      <!-- Informazioni Evento -->
      <div class="cardCustomPopup mb-3">
        <div class="card-headerCustomPopup bg-primary text-white">
          <h5 class="mb-0">
            📋 {{ "CALENDAR.VIEWEVENT.EVENT_INFO" | translate }}
          </h5>
        </div>
        <div class="card-bodyCustomPopup">
          <div class="row">
            <div class="col-md-6 mb-2">
              <strong>{{ "CALENDAR.VIEWEVENT.EVENT_TYPE" | translate }}:</strong>
              <div class="text-muted">
                <span class="badge bg-info me-1">{{ eventData.calendar_type.title }}</span>
                <span class="badge me-1" [class.bg-danger]="eventData.internal === 0"
                  [class.bg-success]="eventData.internal === 1" [class.bg-secondary]="eventData.internal === 2">
                  {{ getInternalTypeLabel(eventData.internal) | translate }}
                </span>
                <span class="badge" [class]="eventData.private ? 'bg-danger' : 'bg-success'">
                  {{ eventData.private ?
                  ("CALENDAR.VIEWEVENT.PRIVATE" | translate) :
                  ("CALENDAR.VIEWEVENT.PUBLIC" | translate) }}
                </span>
              </div>
            </div>
            @if (eventData.room) {
              <div class="col-6 mb-2">
                <strong>{{ "CALENDAR.VIEWEVENT.ROOM" | translate }}:</strong>
                <div class="text-muted">
                  {{ eventData.room.name }}
                  @if (eventData.room.description) {
                    <span class="d-block small text-secondary">
                      {{ eventData.room.description }}
                    </span>
                  }
                </div>
              </div>
            }
            @if (eventData.course) {
              <div class="col-6 mb-2">
                <strong>{{ "CALENDAR.VIEWEVENT.COURSE" | translate }}:</strong>
                <div class="text-muted">
                  <span class="badge" [style.background-color]="eventData.course.color_hex || '#6c757d'">
                    {{ eventData.course.name }}
                  </span>
                  @if (eventData.course.notes) {
                    <span class="d-block small text-secondary mt-1">
                      {{ eventData.course.notes }}
                    </span>
                  }
                </div>
              </div>
            }
            @if (eventData.title) {
              <div class="col-md-6 mb-2">
                <strong>{{ "CALENDAR.VIEWEVENT.EVENT_TITLE" | translate }}:</strong>
                <div class="text-muted">{{ eventData.title }}</div>
              </div>
            }
            @if (eventData.description) {
              <div class="col-12 mb-2">
                <strong>{{ "CALENDAR.VIEWEVENT.DESCRIPTION" | translate }}:</strong>
                <div class="text-muted" style="white-space: pre-wrap">{{ eventData.description }}</div>
              </div>
            }
          </div>
        </div>
      </div>
      <!-- Informazioni Data e Ora -->
      <div class="cardCustomPopup mb-3">
        <div class="card-headerCustomPopup bg-success text-white">
          <h5 class="mb-0">
            📅 {{ "CALENDAR.VIEWEVENT.DATETIME_INFO" | translate }}
          </h5>
        </div>
        <div class="card-bodyCustomPopup">
          <div class="row">
            <div class="col-12 mb-2">
              <strong>{{ "CALENDAR.VIEWEVENT.ALL_DAY" | translate }}: </strong>
              <span class="text-muted">
                <span class=" badge" [class]="eventData.isallday ? 'bg-success' : 'bg-secondary'">
                  {{ eventData.isallday ? ("CALENDAR.VIEWEVENT.YES" | translate) : ("CALENDAR.VIEWEVENT.NO" | translate)
                  }}
                </span>
              </span>
            </div>
            <div class="col-md-6 mb-2">
              <strong>{{ "CALENDAR.VIEWEVENT.START_DATE" | translate }}: </strong>
              <span class="text-muted">{{ eventData.date_start}}</span>
            </div>
            <div class="col-md-6 mb-2">
              <strong>{{ "CALENDAR.VIEWEVENT.END_DATE" | translate }}: </strong>
              <span class="text-muted">{{ eventData.date_end }}</span>
            </div>
            @if (!eventData.isallday) {
              <div class="col-md-6 mb-2">
                <strong>{{ "CALENDAR.VIEWEVENT.START_TIME" | translate }}: </strong>
                <span class="text-muted">{{ eventData.time_start }}</span>
              </div>
            }
            @if (!eventData.isallday) {
              <div class="col-md-6 mb-2">
                <strong>{{ "CALENDAR.VIEWEVENT.END_TIME" | translate }}:</strong>
                <span class="text-muted">{{ eventData.time_end }}</span>
              </div>
            }
          </div>
        </div>
      </div>
      <!-- Informazioni Azienda interno -->
      @if (eventData.internal === 1 && eventData.company_location) {
        <div class="cardCustomPopup mb-3">
          <div class="card-headerCustomPopup bg-secondary text-white">
            <h5 class="mb-0">
              🏛️ {{ "CALENDAR.VIEWEVENT.COMPANY" | translate }}
            </h5>
          </div>
          <div class="card-bodyCustomPopup">
            <div class="row">
              <div class="col-12 mb-2">
                <strong>{{ "CALENDAR.VIEWEVENT.SITE" | translate }}:</strong>
                <div class="text-muted">{{ eventData.company_location.company }} -
                  {{ eventData.company_location.municipality }} -
                  {{ eventData.company_location.address }}, {{ eventData.company_location.house_number }}
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      <!-- Informazioni Cliente -->
      @if (eventData.internal === 0 && eventData.customer) {
        <div class="cardCustomPopup mb-3">
          <div class="card-headerCustomPopup bg-warning text-dark">
            <h5 class="mb-0">
              👤 {{ "CALENDAR.VIEWEVENT.CUSTOMER_INFO" | translate }}
            </h5>
          </div>
          <div class="card-bodyCustomPopup">
            <div class="row">
              <div class="col-md-6 mb-2">
                <strong>{{ "CALENDAR.VIEWEVENT.CUSTOMER_NAME" | translate }}:</strong>
                <div class="text-muted">{{ eventData.customer.denomination }}</div>
              </div>
              @if (eventData.customer.fiscalcode) {
                <div class="col-md-6 mb-2">
                  <strong>{{ "CALENDAR.VIEWEVENT.FISCAL_CODE" | translate }}:</strong>
                  <div class="text-muted">{{ eventData.customer.fiscalcode }}</div>
                </div>
              }
              @if (eventData.customer.vat) {
                <div class="col-md-6 mb-2">
                  <strong>{{ "CALENDAR.VIEWEVENT.VAT" | translate }}:</strong>
                  <div class="text-muted">{{ eventData.customer.vat }}</div>
                </div>
              }
              @if (eventData.customer.headquarter) {
                <div class="col-md-6 mb-2">
                  <strong>{{ "CALENDAR.VIEWEVENT.HEADQUARTEREVENT" | translate }}:</strong>
                  <div class="text-muted">
                    {{ eventData.customer.headquarter.address }}
                    {{ eventData.customer.headquarter.housenumber }},
                    @if (eventData.customer.headquarter.country?.id == 12) {
                      <span>{{
                      eventData.customer.headquarter.municipality?.name}}</span>
                    }
                    @if (eventData.customer.headquarter.country?.id != 12) {
                      <span>{{
                      eventData.customer.headquarter.municipality?.municipality}}</span>
                      } -
                      {{ eventData.customer.headquarter.country?.name }}
                    </div>
                  </div>
                }
                @if (eventData.customer.contact) {
                  <div class="col-md-6 mb-2">
                    <strong>{{ "CALENDAR.VIEWEVENT.CONTACT" | translate }}:</strong>
                    <div class="text-muted">
                      {{eventData.customer.contact.name }} {{eventData.customer.contact.surname }},
                      {{eventData.customer.contact.email1}}
                    </div>
                  </div>
                }
                @if (eventData.customerstudents) {
                  <div class="col-12 mb-2">
                    <strong>{{ "CALENDAR.VIEWEVENT.TRAINEES" | translate }}:</strong>
                    @for (student of eventData.customerstudents; track student) {
                      <span class="text-muted">
                        {{student.name }} {{student.surname }},
                      </span>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        }
        <!-- Tipo di Evento (Interno/Esterno) -->
        <!-- <div class="cardCustomPopup mb-3">
        <div class="card-headerCustomPopup bg-secondary text-white">
          <h5 class="mb-0">
            🏢 {{ "CALENDAR.VIEWEVENT.EVENT_CATEGORY" | translate }}
          </h5>
        </div>
        <div class="card-bodyCustomPopup">
          <div class="row">
            <div class="col-12">
              <strong>{{ "CALENDAR.VIEWEVENT.EVENT_SCOPE" | translate }}:</strong>
              <div class="text-muted">
                <span class="badge" [class.bg-danger]="eventData.internal === 0"
                  [class.bg-success]="eventData.internal === 1" [class.bg-secondary]="eventData.internal === 2">
                  {{ getInternalTypeLabel(eventData.internal) | translate }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <!-- Informazioni Utente -->
      <div class="cardCustomPopup mb-2">
        <div class="card-headerCustomPopup bg-dark text-white">
          <h5 class="mb-0">
            ⚙️ {{ "CALENDAR.VIEWEVENT.SYSTEM_USERS" | translate }}
          </h5>
        </div>
        <div class="px-3 py-1">
          <div class="row">
            <div class="col-12 mb-2">
              <strong>{{ "CALENDAR.VIEWEVENT.ASSOCIATED" | translate }}:</strong>
              @for (item of eventData.users; track item) {
                <span class="text-muted ">
                  {{ item.name }} ({{item.email}}),
                </span>
              }
            </div>
          </div>
          <div class="row" style="font-size: small;">
            @if (eventData.usercreated_at) {
              <div class="col-md-6 mb-2">
                <strong>{{ "CALENDAR.VIEWEVENT.CREATED_BY" | translate }}:</strong>
                <span class="text-muted fst-italic">
                  {{ eventData.usercreated_at.name }} -
                  <small>{{eventData.usercreated_at.created_at }}</small>
                </span>
              </div>
            }
            @if (eventData.userupdated_at) {
              <div class="col-md-6 mb-2">
                <strong>{{ "CALENDAR.VIEWEVENT.LAST_UPDATE" | translate }}:</strong>
                <span class="text-muted fst-italic">
                  {{ eventData.userupdated_at.name }} -
                  <small>{{ eventData.userupdated_at.updated_at }}</small>
                </span>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions class="py-3 px-3 d-flex justify-content-between" style="border-top: 1px solid #e0e0e0">
  <button class="btn btn-outline-primary" (click)="onEdit()">
    <i class="bi bi-pencil me-1"></i>
    {{ "CALENDAR.VIEWEVENT.EDIT" | translate }}
  </button>
  <button class="btn btn-outline-primary" (click)="onClose()">
    {{ "CALENDAR.VIEWEVENT.CLOSE" | translate }}
  </button>
</mat-dialog-actions>
